<div
  class="profile-card"
  [class.expanded]="isExpanded"
  [class.hidden]="!userInitials"
  (mouseover)="cancelCollapseTimeout()"
  (mouseout)="startCollapseTimeout()"
  (click)="stopPropagation($event)"
>
  <div class="header" (click)="toggleCard($event)">
    <span class="name">{{ userFullName }}</span>
    <div class="initials">{{ userInitials }}</div>
  </div>

  <!-- Conditionally show the content only when expanded -->
  <div class="content" *ngIf="isExpanded">
    <div class="email">{{ userEmail }}</div>
    <div class="phone">{{ userPhoneNumber }}</div>
    <div class="position">{{ userPosition }}</div>
    <div class="description">{{ userDescription }}</div>

    <ops-language-switch
      [value]="selectedLanguage"
      (valueChange)="onLanguageChange($event)"
    >
    </ops-language-switch>

    <button
      *ngIf="isSettingsHidden"
      (click)="openSettings()"
      class="settings-btn"
    >
      {{ 'userMenu.settings' | translate }}
    </button>
    <button class="signout-btn" (click)="onSelectAction('logout')">
      {{ 'userMenu.signOut' | translate }}
    </button>
  </div>
</div>
